import { useMemo } from "react";

interface TimelineVideoParams {
  timestamp: Date;
  timestamp_before: number; // seconds
  timestamp_after: number; // seconds
}

/**
 * Hook to calculate timestamp and before/after parameters for video fetching
 * @param startDate - Start date of the timeline range
 * @param endDate - End date of the timeline range
 * @returns Object with timestamp (midpoint) and before/after values in seconds
 */
export const useTimelineVideoParams = (
  startDate: Date,
  endDate: Date
): TimelineVideoParams => {
  return useMemo(() => {
    const startMs = startDate.getTime();
    const endMs = endDate.getTime();

    // Calculate the midpoint timestamp
    const midpointMs = Math.floor((startMs + endMs) / 2);
    const midpointDate = new Date(midpointMs);

    // Calculate before and after in seconds
    const timestamp_before = Math.floor((midpointMs - startMs) / 1000);
    const timestamp_after = Math.floor((endMs - midpointMs) / 1000);

    return {
      timestamp: midpointDate,
      timestamp_before,
      timestamp_after,
    };
  }, [startDate, endDate]);
};
